import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { IntakeFlow } from "~/components/intake/intake-flow";
import { createBrandMeta } from "~/lib/shared/meta";

const intakeSearchSchema = z.object({
  source: z.string().optional(),
  trigger: z.string().optional(),
});

export const Route = createFileRoute("/intake/")({
  validateSearch: intakeSearchSchema,
  head: () =>
    createBrandMeta({
      title: "Discover Your Path | Dream Coach Match",
      description:
        "Answer a few questions and we'll guide you to the right type of coaching support for your situation.",
      ogUrl: "https://dreamcoachmatch.com/intake",
      canonical: "https://dreamcoachmatch.com/intake",
    }),
  component: IntakePage,
});

function IntakePage() {
  const { source, trigger } = Route.useSearch();

  return <IntakeFlow source={source} trigger={trigger} />;
}
